var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_109",
    "data-name": "Rect\\xE1ngulo 109",
    width: 21.946,
    height: 17.324,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_664",
    "data-name": "Grupo 664",
    transform: "translate(-742 -573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    transform: "translate(742 573)",
    fill: "#21b78b",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_622",
    "data-name": "Grupo 622",
    transform: "translate(747.667 581.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_621",
    "data-name": "Grupo 621",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3353",
    "data-name": "Trazado 3353",
    d: "M21.778.162A.529.529,0,0,0,21.4,0H17.845a.858.858,0,0,0-.593.185,2.01,2.01,0,0,0-.309.334L13.823,5l-6,8.038L5.183,9.183a2.056,2.056,0,0,0-.309-.334.859.859,0,0,0-.593-.186H.542a.515.515,0,0,0-.387.161A.506.506,0,0,0,0,9.183a.636.636,0,0,0,.077.3l5.091,7.5a.542.542,0,0,0,.108.16l.009.013v0l.012.014a.555.555,0,0,0,.4.161H9.413a.858.858,0,0,0,.593-.186,1.634,1.634,0,0,0,.284-.309l6.318-8.365L21.842.818a.451.451,0,0,0,.1-.3.49.49,0,0,0-.168-.359",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.34d31c519a82af978decdfb87b7305b1.svg";
export { ForwardRef as ReactComponent };